// Centralized data-testid constants for NEXXIS
export const HOME = {
  emergentLink: "home-emergent-link",
};

export const NAV = {
  root: "top-nav",
  logo: "nav-logo",
  linkHome: "nav-link-home",
  linkAbout: "nav-link-about",
  linkMarkets: "nav-link-markets",
  linkPartners: "nav-link-partners",
  linkHubs: "nav-link-hubs",
  linkContact: "nav-link-contact",
  langToggle: "nav-lang-toggle",
  mobileOpen: "nav-mobile-open",
  mobileSheet: "nav-mobile-sheet",
};

export const PRELOADER = {
  root: "preloader",
  progress: "preloader-progress",
  wordmark: "preloader-wordmark",
};

export const CURSOR = {
  root: "custom-cursor",
};

export const HOMEPAGE = {
  hero: "home-hero",
  heroExplore: "home-hero-explore-button",
  heroGlobe: "home-hero-globe",
  pillars: "home-pillars",
  pillarAccess: "pillar-card-access",
  pillarTrust: "pillar-card-trust",
  pillarGrowth: "pillar-card-growth",
  pillarConnectivity: "pillar-card-connectivity",
  stats: "home-stats",
  stat1: "stat-counter-1",
  stat2: "stat-counter-2",
  stat3: "stat-counter-3",
  editorialIntro: "home-editorial-intro",
  discoverLink: "home-discover-link",
};

export const CONTACT = {
  form: "contact-form",
  name: "contact-name-input",
  email: "contact-email-input",
  message: "contact-message-textarea",
  submit: "contact-submit-button",
  directEmail: "contact-direct-email",
  success: "contact-form-success-toast",
  error: "contact-form-error",
};

export const FOOTER = {
  root: "footer",
  emailLink: "footer-email-link",
};

export const ABOUT = {
  mission: "about-mission",
  vision: "about-vision",
  story: "about-story",
  values: "about-values",
  value1: "about-value-card-1",
  value2: "about-value-card-2",
  value3: "about-value-card-3",
};

export const MARKETS = {
  hero: "markets-hero",
  coverage: "markets-coverage",
  tabs: "markets-instruments-tabs",
  table: "markets-instruments-table",
  miniChart: "markets-mini-chart",
};

export const HUBS = {
  root: "hubs-root",
  medellin: "hub-card-medellin",
  madrid: "hub-card-madrid",
  limassol: "hub-card-limassol",
};

export const PARTNERS = {
  intro: "partners-intro",
  ibs: "partner-segment-ibs",
  affiliates: "partner-segment-affiliates",
  wealth: "partner-segment-wealth-advisors",
  family: "partner-segment-family-offices",
  institutional: "partner-segment-institutional",
};
